export default __webpack_public_path__ + "static/media/cartoon-mouse.a909f477.svg";